function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// hash links should work, untested right now
// TODO: add smoothScroll(elements)
// to add for non-hashed links or something?
// check for target.hash or dataset.scrollTarget
// TODO:
// check for window.scroll
import ally from 'ally.js';

var SmoothScroller = /*#__PURE__*/function () {
  function SmoothScroller() {
    var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var ignored = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, SmoothScroller);

    this.offset = offset;
    this.ignored = ignored;
    this.ignored.push('.smooth--ignore');
    this.findSmoothScrollers();
  }

  _createClass(SmoothScroller, [{
    key: "findSmoothScrollers",
    value: function findSmoothScrollers() {
      var _this = this;

      var links = Array.from(document.querySelectorAll('[data-smooth-target]'));
      if (!this.links || this.links.length === 0) return false;
      links.forEach(function (x) {
        return x.addEventListener('click', function (e) {
          return _this.handleSmoothScroll(e);
        });
      });
    }
  }, {
    key: "handleSmoothScroll",
    value: function handleSmoothScroll(e) {
      e.preventDefault();
      var target = e.target.hash ? document.getElementById(e.target.hash) : document.querySelector(e.dataset.scrollTarget);
      if (!target) return;
      this.scrollTo(target);
    }
  }, {
    key: "scrollTo",
    value: function scrollTo(target) {
      window.scroll({
        top: target.offsetTop - this.offset,
        behavoir: "smooth"
      });
      this.focusTarget(target);
    }
  }, {
    key: "focusTarget",
    value: function focusTarget(target) {
      if (ally.is.focusable(target)) {
        target.focus();
      } else {
        target.tabindex = -1;
        target.focus();
      }
    }
  }, {
    key: "bindHashLinks",
    value: function bindHashLinks() {
      var _this2 = this;

      Array.from(document.querySelectorAll('a[href^="#"]')).filter(function (x) {
        return x.hash !== "#";
      }).forEach(function (x) {
        return x.addEventListener('click', function (e) {
          return _this2.handleSmoothScroll(e);
        });
      });
    }
  }, {
    key: "scrollOnLoad",
    value: function scrollOnLoad() {
      var _this3 = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (!window.location.hash) return false;
      var target = document.getElementById(window.location.hash);
      setTimeout(function () {
        _this3.scrollTo(target);
      }, delay);
    }
  }]);

  return SmoothScroller;
}();

export { SmoothScroller as default };